import React, { useState, useEffect } from 'react';
import './AnimatedText.css';

interface AnimatedTextProps {
  words: string[];
  duration?: number;
}

const AnimatedText: React.FC<AnimatedTextProps> = ({
  words,
  duration = 3000
}) => {
  // const [currentIndex, setCurrentIndex] = useState(0); // Commented out: unused variable
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      // setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length); // Commented out: currentIndex is unused
      setRotation((prevRotation) => prevRotation - 90);
    }, duration);

    return () => clearInterval(interval);
  }, [words.length, duration]);

  return (
    <div className="animated-text-container">
      <div 
        className="animated-text"
        style={{ transform: `rotateX(${rotation}deg)` }}
      >
        {words.map((word, index) => (
          <div 
            key={index}
            className="text-face"
            style={{ 
              transform: `rotateX(${index * 90}deg) translateZ(30px)`,
              opacity: 1
            }}
          >
            {word}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedText;
